export const httpToWs = (url: string) =>
  url?.replace(/^(http)(s)?/, (match, p1, p2) => `ws${p2 || ''}`);
